/**
 * Redacts sensitive fields from axios errors before logging.
 *
 * Axios errors include error.response.data (server body — may echo back the
 * request body with passwords/secrets/seed phrases) and error.config (request
 * headers + data). Neither should ever hit the log.
 *
 * This helper returns ONLY the safe metadata: status, statusText, message,
 * and the URL (with any query string stripped to avoid leaking tokens).
 */

interface RedactedError {
  status?: number;
  statusText?: string;
  message: string;
  url?: string;
  method?: string;
}

export const redactError = (error: unknown): RedactedError => {
  if (!error) return { message: 'unknown error' };

  const err = error as any;
  const response = err?.response;
  const config = err?.config;

  let url: string | undefined;
  if (config?.url) {
    const base = config.baseURL || '';
    const path = config.url;
    const full = typeof path === 'string' && path.startsWith('http') ? path : `${base}${path}`;
    url = full.split('?')[0];
  }

  return {
    status: response?.status,
    statusText: response?.statusText,
    message: err?.message || 'unknown error',
    url,
    method: config?.method ? String(config.method).toUpperCase() : undefined,
  };
};
